import { render, staticRenderFns } from "./userAddSignReply.vue?vue&type=template&id=4848ea87&scoped=true&"
import script from "./userAddSignReply.vue?vue&type=script&lang=js&"
export * from "./userAddSignReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848ea87",
  null
  
)

export default component.exports